import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/dashboard/_authenticated/admin/reports')({
  component: RouteComponent,
  staticData: {
    breadcrumb: ['Reports']
  }
})

function RouteComponent() {
  return (<Outlet />);
}
